import { ChannelkartNetworkPost } from "../services/networkService";

export function delay(delayInms: number) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve(2);
        }, delayInms);
    });
}

export const capitalize = (s: string) => (s && s[0].toUpperCase() + s.slice(1)) || ""

export const snakeCaseToWorld = (s: string) => s.split("_").map(i => capitalize(i)).join(" ")

export function addZeroToValue(value: string | number): string {
    if (typeof value === "number") {
        value = value.toString();
    }
    if (value.length === 1) {
        return "0" + value;
    }
    return value;
}

export function getTodaysDate(): string {
    const today = new Date();
    return today.getFullYear() + '-' + addZeroToValue(today.getMonth() + 1) + '-' + addZeroToValue(today.getDate());
}

export function getCurrentDateWithTime(): string {
    const today = new Date();
    const date = getTodaysDate();
    const time = addZeroToValue(today.getHours()) + ":" + addZeroToValue(today.getMinutes()) + ":" + addZeroToValue(today.getSeconds());
    return `${date} ${time}`;
}

const fileToBlob = (file:File,loginId:string) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = (e) => {
        const some = new Uint8Array(e.target?.result as ArrayBufferLike);
        const blob = new Blob([some], { type: file.type });
        const currentDate = new Date();
        const imgName = loginId + "_" + currentDate.getTime() +"_" +  file.name ;
        resolve({blob:blob, imgName:imgName});
    };
    reader.onerror=()=>{
        reject("error")
    }
    reader.readAsArrayBuffer(file);
    })

type imageRespObj={
        "Uri": string,
        "content-type": string,
        "size": number,
        "name": string,
}

export async function createBlobKey(fileArr: File[], loginId: string):Promise<imageRespObj[]> {
    
    const data = new FormData();
    const result=[] as imageRespObj[];
    for (let i = 0; i < fileArr.length; i++) {
        const resp:any= await fileToBlob(fileArr[i],loginId) as {blob:string,imgName:string};
        data.append("files",resp.blob,resp.imgName);
    }
        var uploadurl = "/v1/uploadMultipleFiles/images";
        const resp = await ChannelkartNetworkPost(uploadurl, data, { "Content-Type": 'multipart/form-data' });
        
        resp?.data.forEach((imgResp:{body:string})=>{
            const parsedJson = JSON.parse(imgResp.body);
            result.push((parsedJson?.features?.[0])as imageRespObj);
        })
        return result;
    }

export const random = (max: number) => Math.floor(Math.random() * max)

export const objectKeys = <Obj>(obj: Obj): (keyof Obj)[] => {
    return Object.keys(obj as any) as (keyof Obj)[];
}

export const camelToStartCase =(text:string)=>{
    const result = text.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
}
export const validDateEmail = (value: string | "")=>{
    const emailRegex = new RegExp(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i); // eslint-disable-line
    if (emailRegex.test(value) || value === "") {
        return true;
    } 
    return false;
}

export const validDateMobile = (value:string | "")=>{
    const mobileRegex = new RegExp("^\\d{10}$");
    if(mobileRegex.test(value) || value===""){
        return true;
    }
    return false;
}

export const capitalizeFirstLetter = (string: string) => 
    string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  
export const normalizeText = (str: string) => str.toLowerCase().replace(/\s+/g, '');